import { render, staticRenderFns } from "./AddVideoTwilio.vue?vue&type=template&id=40075814&scoped=true&lang=pug&"
import script from "./AddVideoTwilio.vue?vue&type=script&lang=js&"
export * from "./AddVideoTwilio.vue?vue&type=script&lang=js&"
import style0 from "./AddVideoTwilio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddVideoTwilio.vue?vue&type=style&index=1&id=40075814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40075814",
  null
  
)

export default component.exports